import { LoadingStateInterface } from 'src/store/loading/state';

export function SET_BOARDS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.boards = loading;
}

export function SET_EXECUTIONS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.executions = loading;
}

export function SET_POSTINGS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.postings = loading;
}

export function SET_STATISTICS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.statistics = loading;
}

export function SET_USERS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.users = loading;
}

export function SET_TASKS_LOADING(
  state: LoadingStateInterface,
  loading: boolean
) {
  state.tasks = loading;
}
